import { FunctionComponent, HTMLAttributes } from 'react';

const IconCircleIRounded: FunctionComponent<
  HTMLAttributes<HTMLOrSVGElement>
> = (props) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.58323 0 0 3.58323 0 8C0 12.4168 3.58323 16 8 16C12.4168 16 16 12.4168 16 8C16 3.58323 12.4168 0 8 0ZM8.27977 3.8082C8.189 3.77018 8.09143 3.75105 7.99303 3.75199C7.8958 3.75292 7.79958 3.77343 7.71044 3.8123C7.62125 3.85118 7.54081 3.90763 7.47392 3.97829C7.40703 4.04895 7.35507 4.13236 7.32113 4.22354C7.28719 4.31472 7.27197 4.41181 7.27638 4.50901L7.50064 9.27352C7.51319 9.54023 7.73309 9.75002 8.0001 9.75001C8.26712 9.75 8.487 9.54019 8.49953 9.27348L8.72336 4.50981L8.7234 4.50901C8.72786 4.41064 8.71222 4.3124 8.67743 4.22029C8.64265 4.12818 8.58944 4.04413 8.52106 3.97327C8.45269 3.90242 8.37059 3.84625 8.27977 3.8082ZM7.56596 12.2399C7.69444 12.3258 7.84548 12.3716 8 12.3716C8.2072 12.3716 8.40592 12.2893 8.55243 12.1428C8.69894 11.9962 8.78125 11.7975 8.78125 11.5903C8.78125 11.4358 8.73543 11.2848 8.64959 11.1563C8.56374 11.0278 8.44173 10.9277 8.29897 10.8686C8.15622 10.8094 7.99913 10.7939 7.84759 10.8241C7.69604 10.8542 7.55683 10.9286 7.44757 11.0379C7.33831 11.1472 7.26391 11.2864 7.23376 11.4379C7.20362 11.5895 7.21909 11.7465 7.27822 11.8893C7.33735 12.0321 7.43749 12.1541 7.56596 12.2399Z"
      fill="currentColor"
    />
  </svg>
);

export default IconCircleIRounded;
